import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { resources } from "@constants/hardcoded-strings";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { MessagingTemplateCache } from "@idw-types/data/messaging-template";
import { WorkflowChangeRequest } from "@idw-types/data/workflow-change-request";
import { WorkflowVisualizationContainer } from "@containers/common/workflow-visualization-container/workflow-visualization-container";
import styles from "./workflow-details-visualization-tab.less";

type WorkflowDetailsVisualizationTabProps = {
    hasUnsubmittedChangeRequest: boolean;
    rpServices: Array<FormattedRpServiceConfiguration>;
    workflowMessagingTemplateCache: MessagingTemplateCache;
    availableLanguages: Array<LocaleTypes>;
    setRpServiceConfigurationsState: (rpServices: Array<FormattedRpServiceConfiguration>) => void;
    setWorkflowMessagingTemplateCache: (workflowMessagingTemplateCache: MessagingTemplateCache) => void;
    primaryRpServiceId: string;
    workflowChangeRequests: Array<WorkflowChangeRequest>;
    selectedLanguage: LocaleTypes;
    onClickArchiveService: (id: string) => void;
    onClickSetAsPrimaryService: (id: string) => void;
    generateStartChangeRequestButton: (
        setWorkflowChangeRequests: (changeRequests: Array<WorkflowChangeRequest>) => void
    ) => React.ReactNode;
};

export const WorkflowDetailsVisualizationTab = (props: WorkflowDetailsVisualizationTabProps) => {
    const {
        hasUnsubmittedChangeRequest,
        rpServices,
        primaryRpServiceId,
        workflowMessagingTemplateCache,
        selectedLanguage,
        availableLanguages,
        workflowChangeRequests,
        setRpServiceConfigurationsState,
        setWorkflowMessagingTemplateCache,
        onClickArchiveService,
        onClickSetAsPrimaryService,
        generateStartChangeRequestButton
    } = props;

    return (
        <div>
            <div className={styles.description}>
                {resources.pages.workflowDetails.tabs.visualization.description}
            </div>
            <WorkflowVisualizationContainer
                hasUnsubmittedChangeRequest={hasUnsubmittedChangeRequest}
                rpServices={rpServices}
                selectedLanguage={selectedLanguage}
                primaryRpServiceId={primaryRpServiceId}
                workflowMessagingTemplateCache={workflowMessagingTemplateCache}
                availableLanguages={availableLanguages}
                generateStartChangeRequestButton={generateStartChangeRequestButton}
                workflowChangeRequests={workflowChangeRequests}
                setRpServiceConfigurationsState={setRpServiceConfigurationsState}
                setWorkflowMessagingTemplateCache={setWorkflowMessagingTemplateCache}
                onClickArchiveService={onClickArchiveService}
                onClickSetAsPrimaryService={onClickSetAsPrimaryService}
            />
        </div>
    );
};